import { createService } from '../../api/createService';
import { ClaimRewardSchema } from './RewardsService.schemas';

export default createService(
  {
    claimReward: {
      method: 'POST',
      url: ({ id }: { id: number }) => `/rewards/${id}`,
      responseSchema: ClaimRewardSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
